import React from "react";
import "./choose-cmpx-dialog.scss";
import ChooseCmpxGraph from "./choose-cmpx-graph/choose-cmpx-graph";

class ChooseCmpxDialog extends React.Component {
    state = {
        cmpx: {
            enabled: false,
            notChanged: false,
            Q: null,
            S: null
        }
    };

    componentDidMount() {
        const { data } = this.props;
        this.setState(prevState => {
            return {
                cmpx: {
                    ...prevState.cmpx,
                    ...data
                }
            };
        });
    }

    onSubmit = e => {
        e.preventDefault();
        const { onSave, onClose } = this.props;
        const {
            cmpx: { Q, S, enabled, notChanged }
        } = this.state;
        const data = { Q, S };
        if (!enabled || notChanged) return;

        onSave(data);
        onClose();
    };

    onClose = () => {
        const { onClose } = this.props;
        const {
            cmpx: { Q, S }
        } = this.state;
        const tempData = { Q, S };
        onClose(tempData);
    };

    onCancel = () => {
        const { onClose } = this.props;
        onClose();
    };

    onNewCmpxChanged = data => {
        this.setState(prevState => {
            return {
                cmpx: {
                    ...prevState.cmpx,
                    ...data
                }
            };
        });
    };

    render() {
        const {
            loc,
            fd,
            data: { Q, S }
        } = this.props;
        const { enabled, notChanged } = this.state.cmpx;
        const disabled = !enabled;
        const ms_pnt = val => (val === undefined || val === null || val === "" ? null : Math.round((val * fd) / 1000));
        return (
            <div className="resizer-container">
                <div className="popup-window popup-window_opened choose-cmpx-popup-window">
                    <button type="button" className="popup-close-btn" onClick={() => this.onClose()}>
                        &times;
                    </button>
                    <form id="cmpxChooseForm" action="#" onSubmit={this.onSubmit}>
                        <h3 className="form-header">{loc("dialogs.chooseReprCmpx.title")}</h3>
                        <div className="form-content">
                            <ChooseCmpxGraph
                                loc={loc}
                                Q={ms_pnt(Q)}
                                S={ms_pnt(S)}
                                xScales={[25, 50]}
                                yScales={[10, 20, 40]}
                                onChanged={this.onNewCmpxChanged}
                            />
                        </div>
                        <div className="form-footer">
                            {disabled ? (
                                <div className="message-block">
                                    <span className="warning-message__text">{loc("dialogs.chooseReprCmpx.firstLastCmpxWarning")}</span>
                                </div>
                            ) : notChanged ? (
                                <div className="message-block">
                                    <span className="imperative-message__text">{loc("dialogs.chooseReprCmpx.current")}</span>
                                </div>
                            ) : null}
                            <input
                                type="submit"
                                className="button button-ok"
                                value={loc("buttons.chooseCmpx")}
                                disabled={disabled || notChanged}
                            />

                            <input
                                type="reset"
                                className="button button-cancel"
                                value={loc("buttons.cancel")}
                                onClick={() => this.onCancel()}
                            />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default ChooseCmpxDialog;
